import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { useForm, Controller } from "react-hook-form";
import { Button, Input, Form } from "antd";
import "./Auth.css";
import { useTranslation } from "react-i18next";

// Import compatible CommonJS
const Constants = require("../Utils/Constants");

const ResetPassword = () => {
  const { t } = useTranslation("Authentication");
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const handleResetPassword = async (values) => {
    if (values.newPassword !== values.confirmPassword) {
      alert(t("alert_password_missmatch"));
      return;
    }

    try {
      const url = `${Constants.SERVER_URL}/reset-password`;
      const payload = {
        token: token,
        new_password: values.newPassword,
      };

      const response = await axios.post(url, payload);

      if (response.status === 200) {
        alert(t("alert_password_changed_successfully"));
        navigate("/login");
      } else {
        alert(
          t(`Backend:${response.data?.message}`) ||
            t("alert_password_error_change")
        );
      }
    } catch (error) {
      alert(
        "Erreur : " +
          (t(`Backend:${error.response?.data?.message}`) ||
            t("alert_password_cannot_be_changed"))
      );
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-form">
        <h2>{t("title_define_new_password")}</h2>

        <Form onFinish={handleSubmit(handleResetPassword)}>
          <div className="input-element">
            <h5>{t("title_new_password")}</h5>
            <Controller
              name="newPassword"
              control={control}
              rules={{
                required: t("error_password_required"),
                pattern: {
                  value:
                    /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]).{8,}$/,
                  message: t("error_password_min_length"),
                },
              }}
              render={({ field }) => <Input.Password {...field} />}
            />
            {errors.newPassword && (
              <p className="error">{errors.newPassword.message}</p>
            )}
          </div>

          <div className="input-element">
            <h5>{t("title_password_confirmation")}</h5>
            <Controller
              name="confirmPassword"
              control={control}
              rules={{ required: t("error_password_confirmation_confirmation") }}
              render={({ field }) => <Input.Password {...field} />}
            />
            {errors.confirmPassword && (
              <p className="error">{errors.confirmPassword.message}</p>
            )}
          </div>

          <div className="input-element">
            <Button type="primary" htmlType="submit" style={{ width: "100%" }}>
              {t("button_confirm")}
            </Button>
          </div>

          <Button type="link" onClick={() => navigate("/login")}>
            {t("button_back")}
          </Button>
        </Form>
      </div>
    </div>
  );
};

export default ResetPassword;
